/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_InactiveInputs */

const en_job_inactive = /** @type {(inputs: Job_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inactive`)
};

const he_job_inactive = /** @type {(inputs: Job_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא פעיל`)
};

/**
* | output |
* | --- |
* | "inactive" |
*
* @param {Job_InactiveInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const job_inactive = /** @type {((inputs?: Job_InactiveInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_InactiveInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_job_inactive(inputs)
	return he_job_inactive(inputs)
});